import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Crosshair } from "@/components/Crosshair";

// Real 404 for unmatched routes — replaces the old blank screen ("No routes matched location").
export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="min-h-screen text-foreground" data-testid="not-found-page">
      <Navbar />
      <div className="max-w-[720px] mx-auto px-4 py-28 text-center">
        <p className="font-mono text-volt text-sm uppercase tracking-[0.2em]">Error 404</p>
        <h1 className="font-heading text-5xl sm:text-6xl font-bold tracking-tight mt-3">Page not found</h1>
        <Crosshair className="my-6" />
        <p className="text-base text-secondary-foreground font-body">
          We couldn't find <span className="text-foreground font-mono break-all">{location.pathname}</span>.
          The page may have moved or never existed.
        </p>
        <div className="mt-7 flex items-center justify-center gap-3">
          <button onClick={() => navigate("/")} data-testid="not-found-home"
            className="bg-olive hover:bg-olive-bright text-white font-heading font-bold uppercase text-sm px-5 py-2.5 transition-colors">
            Back to home
          </button>
          <button onClick={() => navigate("/feed")} data-testid="not-found-feed"
            className="border border-sniper hover:border-olive text-secondary-foreground hover:text-foreground font-mono uppercase text-xs px-5 py-2.5 transition-colors">
            Browse marketplace
          </button>
        </div>
      </div>
    </div>
  );
}
